module.exports = __webpack_public_path__ + "static/media/logo-dark.81cb1b95.png";